import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VMenu,{attrs:{"offset-x":""},scopedSlots:_vm._u([{key:"activator",fn:function(props){return [_vm._t("activator",null,null,props)]}}],null,true)},[_c('ChargerLinks',{attrs:{"charger":_vm.charger}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }